import { ResponseData } from "@/typings";
import { fetchTrackApi, generateFingerprint } from "@/utils/fetch";
import { GetTrackingRecordSaveParams } from "./interface";
import { TrackingPlatform } from "@/shared";
import { clientWindow, isServerRendering } from "@/utils/dom";
import { getUriQuery } from "@/utils/url";
import { UtmList } from "@/shared/constants/track";

const trackingRecordSaveParams = {
  platform: TrackingPlatform.Pc,
  report_time: Math.floor(new Date().getTime() / 1000),
};

export const utmData = () => {
  const url = clientWindow?.location?.href || "";
  const [, search] = url.split("?");
  const urlQuery = getUriQuery(search || "", UtmList);
  return urlQuery;
};

const extUrlData = (params: GetTrackingRecordSaveParams) => {
  const url = clientWindow?.location?.href || "";
  const utmQuery = utmData();
  const { ext } = params;
  const newExt = { ...utmQuery, url, ...ext };
  return newExt;
};

const device_id = !isServerRendering ? generateFingerprint() : "";

export async function fetchTrackingRecordSave(
  params: GetTrackingRecordSaveParams
) {
  return fetchTrackApi<ResponseData<null>>("v1/tracking-record/save", {
    method: "POST",
    body: JSON.stringify({
      ...trackingRecordSaveParams,
      ...params,
      ...utmData(),
      ext: JSON.stringify(extUrlData(params)),
      device_id,
    }),
  });
}
